import { z } from 'zod';

import { apiErrorSchema } from '../../shared/contracts/common.ts';

export class ApiResponseError extends Error {
  constructor(
    readonly status: number,
    message: string,
  ) {
    super(message);
  }
}

export async function parseJsonResponse<Schema extends z.ZodType>(
  response: Response,
  schema: Schema,
  fallbackMessage: string,
): Promise<z.output<Schema>> {
  if (!response.ok) {
    let message = `${fallbackMessage} with status ${response.status}`;
    try {
      const parsed = apiErrorSchema.safeParse(await response.json());
      if (parsed.success) message = parsed.data.error;
    } catch {
      // Keep the status-based message when the response is not JSON.
    }
    throw new ApiResponseError(response.status, message);
  }
  let body: unknown;
  try {
    body = await response.json();
  } catch {
    throw new Error(`Invalid response: ${fallbackMessage}`);
  }
  const parsed = schema.safeParse(body);
  if (!parsed.success) throw new Error(`Invalid response: ${fallbackMessage}`);
  return parsed.data;
}
